import React, { useEffect, useState } from "react";
import { Toast } from "../../Components";
import NotSubscribe from "../../Components/Base/Common/NotSubscribe";
import CreateReview from "../CreateReview/CreateReview";
import ShowOfferDetails from "../CreateReview/ShowOfferDetails";
import { useNavigate } from "react-router-dom";
import { offerService, reviewService } from "../../Services";
import { parseInput } from "../../Components/Constants/AppConstant";

export default function BrandReview({
  setAuth,
  setModal,
  NotifModul,
  user,
  profiles,
  setModalNotification,
  closeCartPanel,
  cartItem,
  goToPricing,
  offerSelectedForReview,
}) {
  const [isloaded, setIsLoaded] = useState(false);
  const [isOfferDetailsloaded, setIsOfferDetailsloaded] = useState(false);
  const [toastList, setToastList] = useState([]);
  const [offerId, setOfferId] = useState(offerSelectedForReview);
  const [readOnly, setReadOnly] = useState(false);
  const [review, setReview] = useState(null);
  const [offerDetails, setOfferDetails] = useState(null);
  const [isUserHasSubscription, setUserHasSubscription] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setUserHasSubscription(
      user !== null
        ? user.data.isUserHasSubscription === 1
          ? true
          : false
        : false
    );
  }, [user]);
  useEffect(() => {
    //setUserHasSubscription(user ? user.data.isUserHasSubscription == 1 ? true : false : false)
    async function fetchDataForOfferReview() {
      try {
        const res = await reviewService.getReviewByOfferId(offerId);
        setIsLoaded(true);

        if (res.success === true) {
          if (res.data !== null) {
            setReadOnly(true);
          } else {
            setReadOnly(false);
          }
          setReview(res.data);
        }
      } catch (err) {
        if (err.apiResponseStatus !== 404) {
          addToast({
            error: true,
            msg: parseInput(err?.message)?.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        }
      }
    }
    async function fetchOfferDetails() {
      try {
        const res = await offerService.getOfferDetailsByOfferId(offerId);
        if (res.data !== null && res.success === true) {
          setOfferDetails(res.data);
          setIsOfferDetailsloaded(true);
          //setIsLoaded(true);
        }
      } catch (err) {
        if (err.apiResponseStatus !== 404) {
          addToast({
            error: true,
            msg: err.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        } else {
          setIsOfferDetailsloaded(true);
        }
      }
    }
    if (offerId === null) {
      gotoOffer();
    } else {
      fetchDataForOfferReview();
      fetchOfferDetails();
    }
  }, []);
  const gotoOffer = () => {
    navigate("/brand/offers");
  };

  const addToast = (data) => {
    const newToastList = [...toastList];
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };

  return (
    <>
      {isUserHasSubscription === true && (
        <>
          <div className="main">
            <div className="main__inner">
              {/* <div className='main__inner-title'>
                <h2>Review</h2>
                <Profile
                  type='brand'
                  setAuth={setAuth}
                  setModal={setModal}
                  NotifModul={NotifModul}
                  user={user}
                  profiles={profiles}
                  setNotifModul={setModalNotification}
                  closeCartPanel={closeCartPanel}
                  cartItem={cartItem}
                />
              </div> */}
              {isOfferDetailsloaded && (
                <ShowOfferDetails
                  user={user.data}
                  offerDetails={offerDetails}
                  gotoOffer={gotoOffer}
                  toastList={toastList}
                  setToastList={setToastList}
                  offerId={offerId}
                />
              )}
              {isloaded && (
                <CreateReview
                  isloaded={isloaded}
                  user={user.data}
                  offerDetails={offerDetails}
                  gotoOffer={gotoOffer}
                  readOnly={readOnly}
                  review={review}
                  toastList={toastList}
                  setToastList={setToastList}
                  offerId={offerId}
                />
              )}
            </div>
          </div>
          {toastList && <Toast list={toastList} setList={setToastList} />}
        </>
      )}
      {isUserHasSubscription === false && user !== null && (
        <>
          <NotSubscribe
            goToPricing={goToPricing}
            type="brand"
            setAuth={setAuth}
            setModal={setModal}
            NotifModul={NotifModul}
            setNotifModul={setModalNotification}
            profiles={profiles}
            closeCartPanel={closeCartPanel}
            user={user}
            cartItem={cartItem}
            title={"Offers"}
            background={"background_offers.png"}
          />
        </>
      )}
    </>
  );
}
